import { Koi } from '@ksyos/koi';
import type { Uuid } from '@common/utils/uuid';
import type { ISchemaContainer } from './schemaContainer';

export interface IFundingSettingsEditValidated {
    compensationCharge: number | null;
    endDate: string | null;
    financedByPreviousService: boolean;
    fundingServicePartId: Uuid | null;
    id?: string;
    isAlternativeFinancing: boolean;
    sendInvoice: boolean;
    startDate: string;
}

const fundingSettingsEdit = Koi.object({
    compensationCharge: Koi.number().allow(null).min(0).integer(),
    endDate: Koi.koi().endDate().allow(null),
    financedByPreviousService: Koi.boolean(),
    fundingServicePartId: Koi.when('sendInvoice', {
        is: Koi.bool().valid(true),
        otherwise: Koi.valid(null),
        then: Koi.string().uuid().allow(null),
    }),
    id: Koi.string().optional(),
    isAlternativeFinancing: Koi.boolean(),
    sendInvoice: Koi.boolean(),
    startDate: Koi.koi().date(),
});

export const fundingSettingsEditSchema = {
    schema: fundingSettingsEdit.options({ convert: false, presence: 'required' }),
};

export interface IFundingSettingsAddValidated extends IFundingSettingsEditValidated {
    serviceGroupSettingId?: string | null;
    serviceOrganizationSettingId?: string | null;
}

export const fundingSettingsAddSchema: ISchemaContainer<IFundingSettingsAddValidated> = {
    schema: fundingSettingsEdit
        .keys({
            serviceGroupSettingId: Koi.string().uuid().optional().allow(null),
            serviceOrganizationSettingId: Koi.string().uuid().optional().allow(null),
        })
        .options({ convert: false, presence: 'required' }),
};
